// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__tU_mU","row":"ProcedureTreatmentSummary_row__2Uanc"};